import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { Constants } from "../../constants/constants";
import { DataTableComponent } from "../table/data-table/data-table";

@Component({
  selector: "adaa-integrity-error",
  imports: [TranslatePipe, CommonModule, DataTableComponent],
  templateUrl: "./integrity-error.html",
  styleUrl: "./integrity-error.scss",
})
export class IntegrityErrorComponent {
  @Input() errorMessages = [];

  modal: NgbActiveModal = inject(NgbActiveModal);
  readonly Constants = Constants;
}
